import React, { useEffect, useState } from "react";
import UnitCountSix from "./child/UnitCountSix";
import EarningStatistic from "./child/EarningStatistic";
import TopPerformanceTwo from "./child/TopPerformanceTwo";
import LatestAppointmentsOne from "./child/LatestAppointmentsOne";
import TotalIncome from "./child/TotalIncome";
import RegistrationsByCourse from "./child/RegistrationsByCourse";
import { findDashboardData } from "../services/dashboard";

const DashBoardLayerEight = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    findDashboardData()
      .then((resp) => setDashboardData(resp.data))
      .catch(() => setDashboardData({}))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <div className='row gy-4'>
        <div className='col-xxxl-9'>
          <div className='row gy-4'>
            {/* UnitCountSix */}
            <UnitCountSix dashboardData={dashboardData} loading={loading} />
            {/* Earning Statistic */}
            <EarningStatistic dashboardData={dashboardData} loading={loading} />

            {/* LatestAppointmentsOne */}
            <LatestAppointmentsOne />

            {/* TopPerformanceTwo */}
            <TopPerformanceTwo />
          </div>
        </div>
        <div className='col-xxxl-3'>
          <div className='row gy-4'>
            {/* TotalIncome */}
            <TotalIncome dashboardData={dashboardData} loading={loading} />

            {/* RegistrationsByCourse */}
            <RegistrationsByCourse dashboardData={dashboardData} loading={loading} />
          </div>
        </div>
      </div>
    </>
  );
};

export default DashBoardLayerEight;
